import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pageTitle: ''
};

const titleSlice = createSlice({
  name: 'title',
  initialState,
  reducers: {
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload;
    }
  }
});

export const { setPageTitle } = titleSlice.actions;
export default titleSlice.reducer;
